/* ============================================================
   Md Exfolierande landing sections — shared JS
   Everything is namespaced (md- / MdBuyBox / MdCompareSlider)
   and guarded so it can never conflict with theme scripts.
   ============================================================ */

(function () {
  'use strict';

  function mdFormatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || '\u20AC{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decimalPart = parts[1] ? decimal + parts[1] : '';
      return units + decimalPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    if (!match) return formatString;
    return formatString.replace(placeholderRegex, value);
  }

  /* -------------------- Md Buy Box -------------------- */
  if (!customElements.get('md-buy-box')) {
    customElements.define(
      'md-buy-box',
      class MdBuyBox extends HTMLElement {
        connectedCallback() {
          this.moneyFormat = this.dataset.moneyFormat || '';
          this.productUrl = this.dataset.productUrl || '';
          this.variants = [];
          var dataEl = this.querySelector('script[data-md-variants]');
          if (dataEl) {
            try {
              this.variants = JSON.parse(dataEl.textContent) || [];
            } catch (e) {
              this.variants = [];
            }
          }

          this.idInput = this.querySelector('input.product-variant-id');
          this.priceEl = this.querySelector('[data-md-price]');
          this.compareEl = this.querySelector('[data-md-compare]');
          this.badgeEl = this.querySelector('[data-md-badge]');
          this.badgeTextEl = this.querySelector('[data-md-badge-text]');
          this.atcBtn = this.querySelector('[data-md-atc]');
          this.buyNowBtn = this.querySelector('[data-md-buy-now]');
          this.qtyInput = this.querySelector('[data-md-qty-input]');
          this.soldOutSpan = this.atcBtn ? this.atcBtn.querySelector('.sold-out-message') : null;
          this.soldOutLabel = this.soldOutSpan ? this.soldOutSpan.textContent.trim() : 'Sold out';
          this.unavailableLabel =
            this.soldOutSpan && this.soldOutSpan.dataset.mdUnavailableLabel
              ? this.soldOutSpan.dataset.mdUnavailableLabel
              : 'Unavailable';

          this.onOptionChange = this.onOptionChange.bind(this);
          this.optionInputs = Array.prototype.slice.call(this.querySelectorAll('input[data-md-option-index]'));
          this.optionInputs.forEach(
            function (input) {
              input.addEventListener('change', this.onOptionChange);
            }.bind(this)
          );

          this.initQty();
          this.initBuyNow();
          this.initSlider();
          this.initCountdown();
        }

        disconnectedCallback() {
          if (this.cdTimer) clearInterval(this.cdTimer);
        }

        /* ----- variants ----- */
        selectedOptions() {
          var values = [];
          this.optionInputs.forEach(function (input) {
            if (input.checked) values[Number(input.dataset.mdOptionIndex)] = input.value;
          });
          return values;
        }

        currentVariant() {
          var selected = this.selectedOptions();
          if (!selected.length) return null;
          return (
            this.variants.find(function (variant) {
              return variant.options.every(function (option, index) {
                return option === selected[index];
              });
            }) || null
          );
        }

        onOptionChange() {
          var variant = this.currentVariant();
          this.updateForVariant(variant);
        }

        updateForVariant(variant) {
          if (!variant) {
            this.toggleBuyable(false, this.unavailableLabel);
            return;
          }
          if (this.idInput) {
            this.idInput.value = variant.id;
            this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (this.priceEl) this.priceEl.innerHTML = mdFormatMoney(variant.price, this.moneyFormat);
          var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (this.compareEl) {
            this.compareEl.innerHTML = hasCompare ? mdFormatMoney(variant.compare_at_price, this.moneyFormat) : '';
          }
          if (this.badgeEl) {
            if (hasCompare) {
              var percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
              if (this.badgeTextEl) {
                var template = this.badgeTextEl.dataset.mdBadgeTemplate || '[percent]%';
                this.badgeTextEl.textContent = template.replace('[percent]', percent);
              }
              this.badgeEl.classList.remove('hidden');
            } else {
              this.badgeEl.classList.add('hidden');
            }
          }
          this.toggleBuyable(variant.available, this.soldOutLabel);
          if (variant.featured_media && variant.featured_media.id) this.goToMedia(variant.featured_media.id);
          if (this.productUrl && window.history && window.history.replaceState) {
            window.history.replaceState({}, '', this.productUrl + '?variant=' + variant.id);
          }
        }

        toggleBuyable(available, message) {
          [this.atcBtn, this.buyNowBtn].forEach(function (btn) {
            if (!btn) return;
            if (available) btn.removeAttribute('aria-disabled');
            else btn.setAttribute('aria-disabled', 'true');
          });
          if (this.atcBtn) {
            var textSpan = this.atcBtn.querySelector('[data-md-atc-text]');
            if (textSpan && this.soldOutSpan) {
              if (available) {
                textSpan.classList.remove('hidden');
                this.soldOutSpan.classList.add('hidden');
              } else {
                if (message) this.soldOutSpan.textContent = message;
                textSpan.classList.add('hidden');
                this.soldOutSpan.classList.remove('hidden');
              }
            }
          }
        }

        /* ----- quantity ----- */
        initQty() {
          if (!this.qtyInput) return;
          var input = this.qtyInput;
          this.querySelectorAll('[data-md-qty-change]').forEach(function (btn) {
            btn.addEventListener('click', function (event) {
              event.preventDefault();
              var step = btn.dataset.mdQtyChange === 'plus' ? 1 : -1;
              var value = parseInt(input.value, 10);
              if (isNaN(value)) value = 1;
              value = Math.max(1, value + step);
              input.value = value;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
          input.addEventListener('change', function () {
            var value = parseInt(input.value, 10);
            if (isNaN(value) || value < 1) input.value = 1;
          });
        }

        /* ----- buy now ----- */
        initBuyNow() {
          if (!this.buyNowBtn) return;
          this.buyNowBtn.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              if (this.buyNowBtn.getAttribute('aria-disabled') === 'true') return;
              var id = this.idInput ? Number(this.idInput.value) : null;
              if (!id) return;
              var qty = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
              this.buyNowBtn.setAttribute('aria-disabled', 'true');
              var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
              if (addUrl.indexOf('.js') === -1) addUrl += '.js';
              fetch(addUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: id, quantity: qty }] }),
              })
                .then(function (response) {
                  return response.json().catch(function () {
                    return {};
                  });
                })
                .then(
                  function (response) {
                    if (response && response.status && response.status !== 200) {
                      this.showError(response.description || response.message || 'Error');
                      this.buyNowBtn.removeAttribute('aria-disabled');
                      return;
                    }
                    var root = window.routes && window.routes.root_url ? window.routes.root_url : '/';
                    if (root.slice(-1) !== '/') root += '/';
                    window.location.href = root + 'checkout';
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.buyNowBtn.removeAttribute('aria-disabled');
                  }.bind(this)
                );
            }.bind(this)
          );
        }

        showError(message) {
          var productForm = this.querySelector('product-form');
          if (productForm && typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage(message);
            return;
          }
          var wrapper = this.querySelector('.product-form__error-message-wrapper');
          if (wrapper) {
            wrapper.removeAttribute('hidden');
            var text = wrapper.querySelector('.product-form__error-message');
            if (text) text.textContent = message;
          }
        }

        /* ----- media slider ----- */
        initSlider() {
          this.track = this.querySelector('[data-md-track]');
          this.dotsWrap = this.querySelector('[data-md-dots]');
          if (!this.track) return;
          this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-md-slide]'));
          if (this.dotsWrap) {
            this.dotsWrap.innerHTML = '';
            if (this.slides.length > 1) {
              this.slides.forEach(
                function (slide, index) {
                  var dot = document.createElement('button');
                  dot.type = 'button';
                  dot.className = 'md-media-dot';
                  dot.setAttribute('aria-label', 'Slide ' + (index + 1));
                  if (index === 0) dot.setAttribute('aria-current', 'true');
                  dot.addEventListener(
                    'click',
                    function () {
                      this.track.scrollTo({ left: this.track.clientWidth * index, behavior: 'smooth' });
                    }.bind(this)
                  );
                  this.dotsWrap.appendChild(dot);
                }.bind(this)
              );
            }
          }
          this.track.addEventListener(
            'scroll',
            function () {
              if (this.scrollDebounce) cancelAnimationFrame(this.scrollDebounce);
              this.scrollDebounce = requestAnimationFrame(this.updateDots.bind(this));
            }.bind(this),
            { passive: true }
          );
        }

        updateDots() {
          if (!this.dotsWrap || !this.track || this.slides.length < 2) return;
          var index = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
          Array.prototype.forEach.call(this.dotsWrap.children, function (dot, i) {
            if (i === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        goToMedia(mediaId) {
          if (!this.track || !this.slides || !this.slides.length) return;
          var index = this.slides.findIndex(function (slide) {
            return slide.dataset.mediaId === String(mediaId);
          });
          if (index > -1) this.track.scrollTo({ left: this.track.clientWidth * index, behavior: 'smooth' });
        }

        /* ----- countdown ----- */
        initCountdown() {
          this.cdHoursEl = this.querySelector('[data-md-cd-h]');
          this.cdMinsEl = this.querySelector('[data-md-cd-m]');
          this.cdSecsEl = this.querySelector('[data-md-cd-s]');
          if (!this.cdHoursEl || !this.cdMinsEl || !this.cdSecsEl) return;
          var durationMs =
            (Number(this.dataset.cdHours || 0) * 3600 + Number(this.dataset.cdMinutes || 0) * 60) * 1000;
          if (durationMs <= 0) durationMs = 12 * 3600 * 1000;
          var storageKey = 'md-cd-' + (this.dataset.sectionId || 'default');
          var deadline = 0;
          try {
            deadline = Number(window.localStorage.getItem(storageKey)) || 0;
          } catch (e) {
            deadline = 0;
          }
          var now = Date.now();
          if (!deadline || deadline <= now || deadline - now > durationMs) {
            deadline = now + durationMs;
            try {
              window.localStorage.setItem(storageKey, String(deadline));
            } catch (e) {
              /* storage unavailable — countdown still runs for this visit */
            }
          }
          this.cdDeadline = deadline;
          this.cdDuration = durationMs;
          this.cdStorageKey = storageKey;
          this.tickCountdown();
          this.cdTimer = setInterval(this.tickCountdown.bind(this), 1000);
        }

        tickCountdown() {
          var remaining = this.cdDeadline - Date.now();
          if (remaining <= 0) {
            this.cdDeadline = Date.now() + this.cdDuration;
            try {
              window.localStorage.setItem(this.cdStorageKey, String(this.cdDeadline));
            } catch (e) {
              /* noop */
            }
            remaining = this.cdDuration;
          }
          var totalSeconds = Math.floor(remaining / 1000);
          var hours = Math.floor(totalSeconds / 3600);
          var mins = Math.floor((totalSeconds % 3600) / 60);
          var secs = totalSeconds % 60;
          this.cdHoursEl.textContent = String(hours).padStart(2, '0');
          this.cdMinsEl.textContent = String(mins).padStart(2, '0');
          this.cdSecsEl.textContent = String(secs).padStart(2, '0');
        }
      }
    );
  }

  /* -------------------- Md Compare Slider -------------------- */
  if (!customElements.get('md-compare-slider')) {
    customElements.define(
      'md-compare-slider',
      class MdCompareSlider extends HTMLElement {
        connectedCallback() {
          var range = this.querySelector('.md-ba__range');
          if (!range) return;
          var update = function () {
            this.style.setProperty('--md-ba-pos', range.value + '%');
          }.bind(this);
          range.addEventListener('input', update);
          update();
        }
      }
    );
  }

  if (!customElements.get('md-auto-ba')) {
    customElements.define(
      'md-auto-ba',
      class MdAutoBa extends HTMLElement {
        connectedCallback() {
          this._slides = Array.prototype.slice.call(this.querySelectorAll('.md-autoba__slide'));
          this._dots = Array.prototype.slice.call(this.querySelectorAll('[data-md-autoba-dot]'));
          if (!this._slides.length) return;
          this._active = 0;
          this._interval = parseInt(this.dataset.interval, 10) || 5000;
          this._autoplay = this.dataset.autoplay === 'true';
          this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this._phase = 0;
          this._elapsed = 0;
          this._holdUntil = 0;
          this._lastT = null;
          var self = this;
          this._dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
              self._go(parseInt(dot.getAttribute('data-md-autoba-dot'), 10) || 0);
              self._elapsed = 0;
            });
          });
          this._slides.forEach(function (slide) {
            var range = slide.querySelector('.md-ba__range');
            if (!range) return;
            range.addEventListener('input', function () {
              slide.style.setProperty('--md-ba-pos', range.value + '%');
              self._holdUntil = (window.performance ? performance.now() : Date.now()) + 3500;
            });
          });
          if (this._autoplay && !this._reduced) {
            this._boundTick = this._tick.bind(this);
            this._raf = requestAnimationFrame(this._boundTick);
          }
        }

        disconnectedCallback() {
          if (this._raf) cancelAnimationFrame(this._raf);
        }

        _go(i) {
          if (i === this._active || !this._slides[i]) return;
          this._slides[this._active].classList.remove('is-active');
          if (this._dots[this._active]) this._dots[this._active].classList.remove('is-active');
          this._active = i;
          this._slides[i].classList.add('is-active');
          if (this._dots[i]) this._dots[i].classList.add('is-active');
        }

        _tick(t) {
          if (this._lastT === null) this._lastT = t;
          var dt = t - this._lastT;
          this._lastT = t;
          if (dt > 0 && dt < 1000) {
            if (this._slides.length > 1) {
              this._elapsed += dt;
              if (this._elapsed >= this._interval) {
                this._elapsed = 0;
                this._go((this._active + 1) % this._slides.length);
              }
            }
            if (t >= this._holdUntil) {
              this._phase += dt * 0.0012;
              var pos = 50 + 38 * Math.sin(this._phase);
              var slide = this._slides[this._active];
              slide.style.setProperty('--md-ba-pos', pos + '%');
              var range = slide.querySelector('.md-ba__range');
              if (range) range.value = pos;
            }
          }
          this._raf = requestAnimationFrame(this._boundTick);
        }
      }
    );
  }
})();
